<template>
  <div class="settings__pages">
    <h1>Settings</h1>
    <v-row>
      <template v-for="(page, index) in pages">
        <v-col v-if="page.router !== 'website.settings.payments'" cols="12" md="4" sm="12" xs="12" xl="3" :key="index">
          <v-card
            class="d-flex align-start pa-4"
            height="100%"
            rounded="lg"
            style="gap: 16px"
            link
            @click="onSelect(page)"
          >
            <div>
              <div
                class="d-flex justify-center align-center backgroundPrimary rounded-lg"
                style="width: 48px; height: 48px;border: solid 1px var(--v-primary-base)"
              >
                <Icon :icon="page.icon" :width="32" class="primary--text" />
              </div>
            </div>
            <div>
              <h3>{{ page.title }}</h3>
              <p>{{ page.des }}</p>
            </div>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import utilities from '@/helpers/utilities';
import { domainService } from '@/apis/domain.s';
import { Icon } from '@iconify/vue2';

export default {
  components: {
    Icon,
  },
  data() {
    return {
      enableRef: false,
      paymentChoice: null,
    };
  },
  computed: {
    ...mapGetters(['user']),
    ...mapState({
      pagePreference: state => state.pagePreference.preference,
    }),
    pages() {
      // const isAdmin =
      //   this.user?.email?.indexOf('@lattehub.com') > -1 ||
      //   ['support@dropnoxe.com', 'admin@dropnoxe.com'].indexOf(this.user?.email) > -1;
      /*
      if (this.pagePreference.businessType === 'dropship' && !isAdmin)
        return [
          {
            icon: 'solar:user-id-outline',
            title: 'Accounts',
            des: 'Manage staff accounts and permissions',
            router: 'website.settings.account',
          },
          {
            icon: 'iconoir:megaphone',
            title: 'Sale Channels',
            des: 'Manage the channels you use to sell your products and services',
            router: 'website.settings.sale-channels',
          },
          {
            icon: 'ph:truck-light',
            title: 'Shipping',
            des: 'Manage how you ship orders to customers',
            router: 'website.settings.shipping',
          },
        ];
        */
      return [
        {
          icon: 'solar:user-id-outline',
          title: 'Accounts',
          des: 'Manage staff accounts and permissions',
          router: 'website.settings.account',
        },
        {
          icon: 'iconoir:megaphone',
          title: 'Sale Channels',
          des: 'Manage the channels you use to sell your products and services',
          router: 'website.settings.sale-channels',
        },
        {
          icon: 'ph:truck-light',
          title: 'Shipping',
          des: 'Manage how you ship orders to customers',
          router: 'website.settings.shipping',
        },
        // {
        //   icon: 'fas fa-shopping-cart',
        //   title: 'Theme',
        //   des: 'Customize your online checkout process',
        //   router: 'website.settings.checkout',
        // },
        // {
        //   icon: 'ion:card-outline',
        //   title: 'Payout',
        //   des: 'Setup and Manage your payouts',
        //   router: 'website.settings.payout',
        // },
        {
          icon: 'fluent:settings-48-regular',
          title: 'General',
          des: 'View and update your store details',
          router: 'website.settings.general',
        },
        // {
        //   icon: 'solar:cart-check-outline',
        //   title: 'Checkout',
        //   des: 'Customize your online checkout process',
        //   router: 'website.settings.checkout',
        // },
        {
          icon: 'pepicons-pencil:bell',
          title: 'Notification',
          des: 'Manage notifications sent to you and your customers',
          router: 'website.settings.notifications',
        },
        {
          icon: 'material-symbols-light:balance',
          title: 'Legal',
          des: `Manage your store's legal pages`,
          router: 'website.settings.legal',
        },
        // {
        //   icon: 'iconamoon:invoice-thin',
        //   title: 'Billing',
        //   des: 'Manage your billing information and view your invoices',
        //   router: 'website.settings.billing',
        // },
        {
          icon: 'la:file-invoice-dollar',
          title: 'Taxes',
          des: 'Manage how your store charge taxes',
          router: 'website.settings.taxes',
        },
      ];
    },
  },
  methods: {
    async checkEnableRef() {
      try {
        const { data } = await domainService.checkEnableRef();
        if (data) {
          this.enableRef = data[0].enableRef;
        }
      } catch (error) {
        console.log('🚀 ~ file: index.vue:137 ~ checkEnableRef ~ error:', error);
      }
    },
    onSelect(page) {
      this.$router.push({
        name:
          page.router !== 'website.settings.payments' || utilities.checkPermisson(`payment_providers`, this.user)
            ? page.router
            : 'no-access',
      });
    },
  },
  mounted() {
    this.checkEnableRef();
    this.paymentChoice = this.pagePreference?.paymentChoice?.type || 'seller';
    // if (
    //   this.pagePreference &&
    //   this.pagePreference?.businessType === 'dropship' &&
    //   this.paymentChoice === 'latte' &&
    //   this.pagePreference?.isTrademark
    // ) {
    //   this.pages.push({
    //     icon: 'fas fa-file-invoice-dollar',
    //     title: 'Payout',
    //     des: 'Manage payout with store Dropship',
    //     router: 'website.settings.payout',
    //   });
    //   this.pages.splice(1, 1);
    // }
  },
  watch: {
    '$store.state.pagePreference.preference'() {
      this.paymentChoice = this.pagePreference?.paymentChoice?.type || 'seller';
      // if (
      //   this.pagePreference &&
      //   this.pagePreference.businessType === 'dropship' &&
      //   this.paymentChoice === 'latte' &&
      //   this.pagePreference?.isTrademark
      // ) {
      //   this.pages.push({
      //     icon: 'fas fa-file-invoice-dollar',
      //     title: 'Payout',
      //     des: 'Manage payout with store Dropship',
      //     router: 'website.settings.payout',
      //   });
      //   this.pages.splice(1, 1);
      // }
    },
  },
};
</script>
